// extracted by mini-css-extract-plugin
export default {"wrapper":"SystemPicker_wrapper__1R3gg","sizes":"SystemPicker_sizes__T6a+-","size":"SystemPicker_size__yfgBg","active":"SystemPicker_active__EGF1F","note":"SystemPicker_note__ahy03"};